var _style, _g, _g2, _path, _g3, _g4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotate10L2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.7 56.7",
    style: {
      enableBackground: "new 0 0 56.7 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#286AA6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,31.4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.2,26c1-8.3,7.4-15.3,16.1-16.7c10.5-1.7,20.4,5.5,22.1,16c1.7,10.5-5.5,20.4-16,22.1 c-1,0.2-2.1,0.2-3.1,0.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.1,24.9 9.3,31.4 5.6,24.9  "
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.9,28.3c0,2.4,2,4.4,4.4,4.4s4.4-2,4.4-4.4c0-2.4-2-4.4-4.4-4.4C25.9,23.9,23.9,25.9,23.9,28.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.7,28.3C56.7,44,44,56.7,28.3,56.7C12.7,56.7,0,44,0,28.3S12.7,0,28.3,0C44,0,56.7,12.7,56.7,28.3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,31.4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.2,26c1-8.3,7.4-15.3,16.1-16.7c10.5-1.7,20.4,5.5,22.1,16c1.7,10.5-5.5,20.4-16,22.1 c-1,0.2-2.1,0.2-3.1,0.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "13.1,24.9 9.3,31.4 5.6,24.9  "
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.9,28.3c0,2.4,2,4.4,4.4,4.4c2.4,0,4.4-2,4.4-4.4c0-2.4-2-4.4-4.4-4.4C25.9,23.9,23.9,25.9,23.9,28.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate10L2);
export default __webpack_public_path__ + "static/media/rotate_10_l_2.4e5c626d3ceed7c0ccbf3830402554f9.svg";
export { ForwardRef as ReactComponent };